import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { VESSEL_DATA } from './types/vessel';

interface VesselSelectorProps {
  onVesselSelect: (vesselName: string) => void;
  selectedVessel: string;
}

const VesselSelector: React.FC<VesselSelectorProps> = ({ onVesselSelect, selectedVessel }) => {
  return (
    <div className="w-full max-w-xs">
      <Select value={selectedVessel} onValueChange={onVesselSelect}>
        <SelectTrigger>
          <SelectValue placeholder="Select a vessel" />
        </SelectTrigger>
        <SelectContent>
          {Object.keys(VESSEL_DATA).map((vesselName) => (
            <SelectItem key={vesselName} value={vesselName}>
              {vesselName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default VesselSelector; 